// extracted by mini-css-extract-plugin
module.exports = {"root":"BtnsActionsTenant_root__2-IHV","btnAction":"BtnsActionsTenant_btnAction__2cbpR"};